import OrderApi from "@/api/order.js";
import SupplierApi from "@/api/supplier.js";

const isSecurity = async function() {
  /*总充值金额*/
  const getTotalRechargeAmount = async () => {
    const defaultParams = {};
    const { data } = await SupplierApi.getLogData(defaultParams, true);
    return data.total_money;
  };

  /*消费总金额*/
  const getTotalConsumeAmount = async () => {
    const defaultParams = {
      user_id: "",
      type: "",
      create_time: "",
      page: 1,
      list_rows: 10
    };
    const { data } = await OrderApi.zhangdan(defaultParams, true);
    return data.count.toFixed(2);
  };

  const [rechargeAmount, consumeAmount] = await Promise.all([
    getTotalRechargeAmount(),
    getTotalConsumeAmount()
  ]);

  console.log("rechargeAmount", rechargeAmount);
  console.log("consumeAmount", consumeAmount);
  return rechargeAmount > consumeAmount;
};

export default isSecurity;



// WEBPACK FOOTER //
// ./src/utils/isSecurity.js